export const getMessage = (state) => state.ui.message.message;

export const getSimVisibility = (state) => state.ui.visibility_sim;

export const getDualVisibility = (state) => state.ui.visibility_dual;

export const isDrawerOpen = (state) => state.ui.drawer.open;
